import { useMemo } from 'react';
import { isValuelessOperator, type FilterValue } from '../types';

/**
 * Filters out incomplete filter values to return only active filters.
 * A filter is active when it has a field, an operator, and either at least one
 * value or a value-less operator (Is Empty / Is Not Empty), which is complete
 * with an empty value array.
 */
export function useDataTableActiveFilters(
  filters: FilterValue[]
): FilterValue[] {
  return useMemo(() => {
    return filters.filter(filter => {
      const hasCompleteValue =
        (filter.value && filter.value.length > 0) ||
        isValuelessOperator(filter.operator);
      return Boolean(filter.field && filter.operator && hasCompleteValue);
    });
  }, [filters]);
}
